module.exports = __webpack_public_path__ + "img/barva-zakladni_08_modra.8a716210.png";